// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 284 ? "ba1712fc" : chunkId) + "." + {"284":"22db8dc83496e7a7","493":"3b01b5ebc1159612"}[chunkId] + ".js";
};